module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-0f1dcf3b100fdc59584e2436c7099ee5.webp";